import type { components } from "../api/generated/survey-svc";

export const AUTH_PROVIDER_COMPLETION_PATH = "/auth/provider/complete";

export const AUTH_PROVIDER_ORDER = [
  "google",
  "microsoft",
  "apple",
] as const satisfies readonly components["schemas"]["AuthProvider"][];

export type AuthProvider = (typeof AUTH_PROVIDER_ORDER)[number];

export type AuthProviderFlags = Record<AuthProvider, boolean>;

export type AuthProviderEnvironment = {
  VITE_AUTH_GOOGLE_ENABLED?: unknown;
  VITE_AUTH_MICROSOFT_ENABLED?: unknown;
  VITE_AUTH_APPLE_ENABLED?: unknown;
};

export const isExactTrue = (value: unknown): boolean => value === "true";

export function readAuthProviderFlags(
  environment: AuthProviderEnvironment,
): AuthProviderFlags {
  return {
    google: isExactTrue(environment.VITE_AUTH_GOOGLE_ENABLED),
    microsoft: isExactTrue(environment.VITE_AUTH_MICROSOFT_ENABLED),
    apple: isExactTrue(environment.VITE_AUTH_APPLE_ENABLED),
  };
}

export const authProviderFlags = readAuthProviderFlags({
  VITE_AUTH_GOOGLE_ENABLED: import.meta.env.VITE_AUTH_GOOGLE_ENABLED,
  VITE_AUTH_MICROSOFT_ENABLED: import.meta.env.VITE_AUTH_MICROSOFT_ENABLED,
  VITE_AUTH_APPLE_ENABLED: import.meta.env.VITE_AUTH_APPLE_ENABLED,
});

export function getEnabledAuthProviders(
  flags: AuthProviderFlags = authProviderFlags,
): AuthProvider[] {
  return AUTH_PROVIDER_ORDER.filter((provider) => flags[provider]);
}
